import React from 'react';
import {Api, Loader} from 'frontend-core';
import {IconButton, Menu, MenuItem, WithStyles, withStyles} from '@material-ui/core';
import styles from './main.style';
import {AccountCircle} from '@material-ui/icons';
import {Props} from './main';

interface State {
  menu?: any;
  isLogout: boolean;
}

class MainUser extends React.Component<Props & WithStyles<typeof styles>, State> {
  state = {
    menu: undefined,
    isLogout: false
  };

  /**
   * Открыть меню
   * @param event
   */
  openMenu = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({menu: event.currentTarget});
  };

  /**
   * Закрыть меню
   */
  closeMenu = () => {
    this.setState({menu: undefined});
  };

  /**
   * Выход
   */
  onLogout = () => {
    const {user} = this.props;
    this.setState({
      isLogout: true
    });
    localStorage.removeItem('kc_token');
    localStorage.removeItem('kc_refreshToken');
    user && user.kc.logout();
  };

  render() {
    const {menu, isLogout} = this.state;
    const {classes} = this.props;

    return (
      <React.Fragment>
        <IconButton
          color='inherit'
          aria-owns={menu ? 'user-menu' : undefined}
          aria-haspopup='true'
          onClick={this.openMenu}
        >
          <AccountCircle />
        </IconButton>
        <Menu
          id='user-menu'
          anchorEl={menu}
          open={Boolean(menu)}
          onClose={this.closeMenu}
          getContentAnchorEl={null}
          anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
          transformOrigin={{vertical: 'top', horizontal: 'center'}}
        >
          <MenuItem dense={true} onClick={this.onLogout}>
            <span className={isLogout ? classes.logout : ''}>Выход</span>
            {isLogout && (
              <div className={classes.loaderWrapper}>
                <Loader size={20} />
              </div>
            )}
          </MenuItem>
        </Menu>
      </React.Fragment>
    );
  }
}

export default withStyles(styles, {name: 'MainUser'})(MainUser);
